import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { applyMeta, pageMeta } from '../seo.js';
import { EDITORIAL_ROUTES } from '../content/index.js';

const META = EDITORIAL_ROUTES.find(r => r.path === '/about');

export default function About() {
  useEffect(() => applyMeta(pageMeta({
    path: '/about',
    title: META.title,
    description: META.description,
  })), []);

  return (
    <article className="page-prose">
      <h1 className="page-heading">About TalkMuch</h1>

      <h2>Why this exists</h2>
      <p>
        This started because I am a heavy Joe Rogan listener, five episodes a week. The ones
        I actually look for are the episodes where the guest dominates the talk time. Those
        tend to be the better conversations: the host has found someone worth listening to
        and got out of the way.
      </p>
      <p>
        The problem is that the only way to find out how much a guest actually got to talk
        was to listen to the whole thing. A three-hour episode where the host talks over the
        guest is three hours you do not get back. TalkMuch answers that question before you
        press play.
      </p>

      <h2>What we measure</h2>
      <p>
        For every episode we process, we transcribe the audio, separate the speakers, work
        out which one is the host, strip the sponsor reads, and then measure who held the
        floor. The number you see is a share of actual conversation time, not of episode
        length. Advertising breaks and pre-roll are removed before anything is counted.
      </p>
      <p>
        Alongside the talk split we publish how many questions each side asked, how often
        the conversation changed hands, and the longest stretch either person spoke without
        interruption. Those four numbers together tell you more about the shape of an
        episode than any summary does.
      </p>

      <h2>What we do not do</h2>
      <p>
        We do not republish transcripts, and we do not rank episodes by quality. A host
        talking 70% of the time is not doing anything wrong; some shows are built that way.
        The figures describe a conversation, they do not grade it.
      </p>
      <p>
        We are also open about where the measurement is soft. Speaker separation gets things
        wrong, question counts overstate real questions when someone is telling a story, and
        a few shows defeat our host detection entirely. All of that is written up in{' '}
        <Link to="/methodology">the methodology</Link>, including the cases where we
        decided our own tooling was not good enough and said so.
      </p>

      <p>
        If a figure looks wrong, it might be. Corrections are genuinely welcome, and every
        one we receive gets checked against the transcript. <Link to="/contact">Get in touch</Link>.
      </p>
    </article>
  );
}
